module.exports = __webpack_public_path__ + "static/media/Mightyena_gaussian2.ab2471b9.png";